module.exports = __webpack_public_path__ + "img/icon_user.3e377afd.png";